import {z} from "zod";

export const ContentItem = z.object({
    id: z.number().optional(),
    url: z.string(),
    domain: z.string(),

    title: z.string(),
    tags: z.array(z.string()).optional(),

    summary: z.string().optional(),
    published_at: z.date(),
    category: z.object({
        slug: z.string(),
        name: z.string(),
	custom_fields: z.object(z.any()).optional(),
    }),

    topic: z
        .object({
            name: z.string(),
            slug: z.string(),
        })
        .optional(),

    poster: z
        .object({
            url: z.string(),
            crop: z.string().optional(),
        })
        .optional(),

    source: z.object({
        id: z.number(),
        name: z.string(),
        source: z.object({
            name: z.string(),
            source: z.any(),
        }).optional()
    }).optional(),

    authors: z.array(z.object({
        id: z.number(),
        name: z.string(),
        avatar: z.object({
            id: z.string(),
            url: z.string(),
        }).optional(),
        custom_fields: z.any().optional(),
    })).optional(),

    custom_fields: z.object(z.any()).optional(),

});

export default z.object({
    layout: z.string(),
    content: ContentItem,
    custom_fields: z.any().optional(),
});
